export default __webpack_public_path__ + "static/media/Netflix-Logo.ac27d71a.png";